export default {"src":"/_next/static/media/Versatile.a2959513.svg","height":80,"width":80};